import { CIcon } from '~/icons/types'

export const ciLink: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M7 8.5h2a1.5 1.5 0 1 0 0-3H7a6.46 6.46 0 0 0-4.597 1.904A6.46 6.46 0 0 0 .5 12a6.46 6.46 0 0 0 1.903 4.596A6.462 6.462 0 0 0 7 18.5h2a1.5 1.5 0 1 0 0-3H7a3.477 3.477 0 0 1-2.475-1.025A3.479 3.479 0 0 1 3.5 12c0-.935.364-1.814 1.025-2.475A3.477 3.477 0 0 1 7 8.5Zm14.596-1.096A6.457 6.457 0 0 0 17 5.5h-2a1.5 1.5 0 1 0 0 3h2c.935 0 1.813.364 2.475 1.025A3.477 3.477 0 0 1 20.5 12c0 .936-.364 1.813-1.026 2.475A3.473 3.473 0 0 1 17 15.5h-2a1.5 1.5 0 0 0 0 3h2a6.46 6.46 0 0 0 4.596-1.903A6.462 6.462 0 0 0 23.5 12a6.458 6.458 0 0 0-1.904-4.596Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'link',
  type: 'solid'
}
